import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ drawerProducts }: RootState) => drawerProducts;

export const selectDrawerProduct = createSelector(
    selectRoot,
    ({ drawerProducts }) => drawerProducts,
);
